"use client";

import React from "react";

import NumberFlow, { Format, Value } from "@number-flow/react";

interface NumberFlowProps {
  value: Value;
  format: Format;
  className?: string;
}

export function FormattedNumber({ value, format, className }: NumberFlowProps) {
  return <NumberFlow format={format} value={value} className={className} />;
}
